export class AccountSentMetricsModel {
    sentMetrics;
}
//# sourceMappingURL=account-sent-metrics.js.map